var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1.2207C0.992603 1.39938 1.22321 1.57809 1.42409 1.73484C1.825 2.04775 2.36202 2.47853 2.90102 2.94655C3.43657 3.41154 3.99024 3.9271 4.41552 4.40842C4.62743 4.64825 4.82233 4.89619 4.96807 5.13794C5.10215 5.36038 5.25 5.66605 5.25 6.00044C5.25 6.33484 5.10215 6.64058 4.96807 6.86301C4.82233 7.10477 4.62743 7.35263 4.41552 7.59249C3.99024 8.07382 3.43657 8.58935 2.90102 9.05439C2.36202 9.52237 1.825 9.95313 1.42409 10.2661C1.22321 10.4228 0.992604 10.6016 0.750007 10.7802",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrow-next.b7bc8bf68f6115dd32f1d1bedc825075.svg";
export { ForwardRef as ReactComponent };